/** @module app.test.pages */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { TestContainer } from 'app/test/container';
import { TestContext } from 'app/test/context';
import { ITestResult, ITestSession } from 'app/test/types';
import { IAccordion } from 'app/shared/attributes/ess-collapse-attributes';
import { IPopup } from 'app/shared/elements/popup-base';

interface ITestResultGroup {
    fixture: string;
    passed: number;
    failed: number;
    results: ITestResult[];
}

@autoinject
export class UnitTestsPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////

    //protected results: ITestResult[] = [];
    protected groups: ITestResultGroup[] = [];
    protected session: ITestSession | null = null;

    protected fixture: string = '';
    protected test: string = '';
    protected args: string = '';
    protected output: string = '';
    protected error: string = '';
    protected stack: string = '';

    ////****************** Element References ***************************************////

    private accordion!: IAccordion;
    private resultsDialog!: IPopup;

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(private readonly container: TestContainer, ...rest: any[]) {
        super(...rest);
    }

    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////

    protected handleRunTestsClick(event: Event): void {
        this.runTests();
    }

    ////****************** Functions ************************************************////

    private organizeResults(results: ITestResult[]): ITestResultGroup[] {
        const groups: ITestResultGroup[] = [];

        let lastFixture: string = '';
        let group: ITestResultGroup | null = null;
        for(const result of results) {
            if(!group || result.fixture !== lastFixture) {
                group = { fixture: result.fixture, results: [], passed: 0, failed: 0 };
                groups.push(group);
                lastFixture = result.fixture;
            }

            if(result.passed) {
                group.passed++;
            }
            else {
                group.failed++;
            }
            group.results.push(result);
        }

        return groups;
    }

    private async runTests(): Promise<void> {
        try {
            this.state.beginLoad();

            const context = new TestContext();
            this.session = context;

            const runner = await this.container.createRunner(context);
            await runner.run(context);

            this.groups = this.organizeResults(context.results);
        }
        finally {
            this.state.endLoad();
        }
    }

    protected showResult(result: ITestResult): void {
        this.fixture = result.fixture;
        this.test = result.test;
        this.args = result.args;
        this.error = result.error && result.error.constructor.name || '';
        this.stack = result.error && result.error.stack || '';
        this.output = result.output.join('\n');

        this.resultsDialog.open();
    }

    ////****************** Service Calls ********************************************////

}
